const fallback = () => {
  console.error('Incorrect Splitter data provider.');
  return Promise.reject();
};
const dp = {
  getSize: fallback,
  setSize: fallback
};
export const getSplitterDataProvider = () => {
  return dp;
};
//# sourceMappingURL=SplitterDataProvider.js.map